import VrrProgress from './VrrProgress';

export default VrrProgress;
